<template>
  <BaseClearButton :size="size || 'large'" :color="color" :type="type" :disabled="disabled">
    <i
      slot="icon-only"
      :class="{ [icon]: true, 'text-2xl': size === 'large' || size === 'default', 'text-base': size === 'small' }"
    ></i>
  </BaseClearButton>
</template>

<script setup lang="ts">
import BaseClearButton from './BaseClearButton.vue';

defineProps<{
  icon: string;
  size?: 'large' | 'small' | 'default';
  type?: 'button' | 'reset' | 'submit';
  color?: 'primary' | 'danger' | 'light' | 'medium' | 'cyan' | 'dark' | 'white';
  disabled?: boolean;
}>();
</script>

<style scoped></style>
